import React from "react";

const Awareness = () => {
  const awarenessPrograms = [
    {
      icon: "🌱",
      title: "पर्यावरण शिक्षा",
      description:
        "स्कूलों और कॉलेजों में पर्यावरण संरक्षण की महत्ता पर जागरूकता कार्यक्रम",
      activities: ["पोस्टर प्रतियोगिता", "प्रकृति शिविर", "वृक्षारोपण अभियान"],
    },
    {
      icon: "♻️",
      title: "पुनर्चक्रण जागरूकता",
      description: "कचरे के पुनर्चक्रण और पुनः उपयोग की जानकारी",
      activities: ["कचरा प्रबंधन", "कंपोस्ट बनाना", "प्लास्टिक मुक्ति"],
    },
    {
      icon: "💧",
      title: "जल संरक्षण",
      description: "पानी की बचत और वर्षा जल संचयन के तरीके",
      activities: ["वर्षा जल संचयन", "जल शुद्धीकरण", "भूजल संरक्षण"],
    },
    {
      icon: "🔋",
      title: "ऊर्जा संरक्षण",
      description: "नवीकरणीय ऊर्जा और ऊर्जा की बचत के उपाय",
      activities: ["सोलर ऊर्जा", "LED उपयोग", "ऊर्जा की बचत"],
    },
  ];

  const tips = [
    {
      icon: "🌿",
      tip: "प्रतिदिन कम से कम एक पौधे की देखभाल करें",
    },
    {
      icon: "🚫",
      tip: "प्लास्टिक बैग के बजाय कपड़े या कागज़ के थैले का उपयोग करें",
    },
    {
      icon: "💡",
      tip: "बिजली की बचत करें - अनावश्यक लाइट और पंखे बंद करें",
    },
    {
      icon: "🚲",
      tip: "छोटी दूरी के लिए साइकिल या पैदल चलें",
    },
    {
      icon: "🗑️",
      tip: "कचरे को अलग करें - गीला और सूखा कचरा अलग रखें",
    },
    {
      icon: "🌧️",
      tip: "वर्षा के पानी को इकट्ठा करें और पौधों को पानी दें",
    },
  ];

  return (
    <section id="awareness" className="awareness">
      <div className="container">
        <h2 className="section-title">💡 जागरूकता कार्यक्रम</h2>
        <p className="section-subtitle">
          पर्यावरण संरक्षण के लिए समुदायिक जागरूकता और शिक्षा कार्यक्रम
        </p>

        <div className="awareness-programs">
          <h3 className="subsection-title">🎯 हमारे जागरूकता कार्यक्रम</h3>
          <div className="programs-grid">
            {awarenessPrograms.map((program, index) => (
              <div key={index} className="program-card">
                <span className="program-icon">{program.icon}</span>
                <h4>{program.title}</h4>
                <p>{program.description}</p>
                <div className="activities">
                  <h5>गतिविधियां:</h5>
                  <ul>
                    {program.activities.map((activity, idx) => (
                      <li key={idx}>{activity}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="eco-tips">
          <h3 className="subsection-title">💡 पर्यावरण संरक्षण के सरल उपाय</h3>
          <div className="tips-grid">
            {tips.map((tip, index) => (
              <div key={index} className="tip-card">
                <span className="tip-icon">{tip.icon}</span>
                <p>{tip.tip}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="call-to-action-awareness">
          <div className="cta-content">
            <h3>🤝 हमारे साथ जुड़ें</h3>
            <p>
              पर्यावरण संरक्षण में अपना योगदान दें। आज ही हमारे जागरूकता
              कार्यक्रमों में भाग लें और एक स्वच्छ, हरित भविष्य का निर्माण करने
              में हमारी मदद करें।
            </p>
            <div className="cta-stats">
              <div className="stat">
                <span className="number">500+</span>
                <span className="label">👥 जागरूक नागरिक</span>
              </div>
              <div className="stat">
                <span className="number">25+</span>
                <span className="label">🎓 शिक्षा कार्यक्रम</span>
              </div>
              <div className="stat">
                <span className="number">100%</span>
                <span className="label">🆓 निःशुल्क सेवा</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Awareness;
